export default __webpack_public_path__ + "643731f9bf2394327c698159ccf6bb46.png";